import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-cresento-primary/90 backdrop-blur-md border-b border-cresento-secondary/30">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-cresento-secondary to-cresento-accent bg-clip-text text-transparent">
            Cresento
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-cresento-light hover:text-white transition-colors">
              Home
            </Link>
            {/* <Link to="/our-drive" className="text-cresento-light hover:text-white transition-colors">
              Our Drive
            </Link> */}
            <Link to="/level-up" className="text-cresento-light hover:text-white transition-colors">
              Level Up Your Game
            </Link>
            <Link to="/investors" className="text-cresento-light hover:text-white transition-colors">
              For Partners, Sponsors, Investors
            </Link>
            <Link to="/faq" className="text-cresento-light hover:text-white transition-colors">
              FAQ
            </Link>
            <Link to="/contact" className="text-cresento-light hover:text-white transition-colors">
              Get in Touch
            </Link>
            
            {user ? (
              <>
                <Link to="/dashboard" className="text-cresento-light hover:text-white transition-colors">
                  Dashboard
                </Link>
                <button 
                  onClick={handleLogout} 
                  className="bg-gradient-to-r from-cresento-secondary to-cresento-accent hover:from-cresento-secondary/90 hover:to-cresento-accent/90 text-white px-4 py-2 rounded-lg font-semibold transition-all duration-300"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-cresento-light hover:text-white transition-colors">
                  Login
                </Link>
                <Link 
                  to="/level-up" 
                  className="bg-gradient-to-r from-cresento-secondary to-cresento-accent hover:from-cresento-secondary/90 hover:to-cresento-accent/90 text-white px-4 py-2 rounded-lg font-semibold transition-all duration-300"
                >
                  Sign Up for Updates
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-cresento-secondary/30">
            <div className="flex flex-col space-y-4 pt-4">
              <Link to="/" className="text-cresento-light hover:text-white transition-colors" onClick={() => setIsMenuOpen(false)}>
                Home
              </Link>
              {/* <Link to="/our-drive" className="text-cresento-light hover:text-white transition-colors" onClick={() => setIsMenuOpen(false)}>
                Our Drive
              </Link> */}
              <Link to="/level-up" className="text-cresento-light hover:text-white transition-colors" onClick={() => setIsMenuOpen(false)}>
                Level Up Your Game
              </Link>
              <Link to="/investors" className="text-cresento-light hover:text-white transition-colors" onClick={() => setIsMenuOpen(false)}>
                For Partners, Sponsors, Investors
              </Link>
              <Link to="/faq" className="text-cresento-light hover:text-white transition-colors" onClick={() => setIsMenuOpen(false)}>
                FAQ
              </Link>
              <Link to="/contact" className="text-cresento-light hover:text-white transition-colors" onClick={() => setIsMenuOpen(false)}>
                Get in Touch
              </Link>
              
              {user ? (
                <>
                  <Link to="/dashboard" className="text-cresento-light hover:text-white transition-colors" onClick={() => setIsMenuOpen(false)}>
                    Dashboard
                  </Link>
                  <button
                    onClick={() => {
                      handleLogout();
                      setIsMenuOpen(false);
                    }}
                    className="bg-gradient-to-r from-cresento-secondary to-cresento-accent hover:from-cresento-secondary/90 hover:to-cresento-accent/90 text-white px-4 py-2 rounded-lg font-semibold transition-all duration-300 w-full"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="text-cresento-light hover:text-white transition-colors" onClick={() => setIsMenuOpen(false)}>
                    Login
                  </Link>
                  <Link 
                    to="/level-up" 
                    className="bg-gradient-to-r from-cresento-secondary to-cresento-accent hover:from-cresento-secondary/90 hover:to-cresento-accent/90 text-white px-4 py-2 rounded-lg font-semibold transition-all duration-300 w-full text-center"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Sign Up for Updates
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
